import moment from 'moment';

export default class ImageData {
    public guid: string;
    public thumbnailData: string = '';
    public largeData: string = '';
    public originalData: string = '';
    public width: number = null;
    public height: number = null;

    constructor(
        guid: string,
        originalData: string | null,
        width: number,
        height: number,
    ) {
        this.guid = guid;
        this.width = width;
        this.height = height;

        if (originalData != null) {
            this.originalData = originalData;
        }
    }

    get hasData() {
        return (
            this.originalData !== ''
         || this.thumbnailData !== ''
         || this.largeData !== ''
        );
    }

    public ratio() {
        return this.width / this.height;
    }
}
